import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faBell } from "@fortawesome/free-solid-svg-icons"

export const Bell = (props) => {
  return <FontAwesomeIcon faIcon={faBell} {...props} />
}
